import React from "react";

const NEWS = [
  {
    title: "Biofuels to play key role in India's agriculture and rural sectors",
    url: "https://newsonair.gov.in/minister-nitin-gadkari-biofuels-to-play-key-role-in-indias-agriculture-and-rural-sectors/",
    // thumbnail file (place the attached image at public/generated/news1.jpg)
    thumb: "/generated/news1.jpg",
  },
  {
    title: "US President follows Nitin Gadkari's footsteps, gives a push to biofuel",
    url: "https://www.ndtv.com/auto/us-president-donald-trump-follows-nitin-gadkaris-footsteps-gives-a-push-to-biofuel-11290904",
    // thumbnail file (place the attached image at public/generated/news2.jpg)
    thumb: "/generated/news2.jpg",
  },
];


export default function Initiatives() {
  return (
    <section id="projects" className="relative py-16 md:py-20 overflow-hidden">
      <div className="max-w-7xl mx-auto px-6 md:px-10">

        {/* Biofuel intro + Latest News */}
        <div className="mb-12">
          <div className="reveal max-w-3xl">
            <span className="overline">About Biofuels</span>
            <h3 className="text-3xl md:text-4xl font-semibold mt-1 leading-tight">What is Biofuel?</h3>
            <p className="text-white/70 mt-2 text-lg leading-relaxed">
              Biofuels are renewable fuels produced from biological materials — such as plant oils, agricultural residues, and specially grown energy crops. They can be used as direct replacements or blends for conventional petrol and diesel and are designed to reduce net greenhouse gas emissions when produced and used sustainably.
            </p>
            <p className="text-white/70 mt-2 text-lg leading-relaxed">
              Common types include <strong>bioethanol</strong> (made from sugars and starches) and <strong>biodiesel</strong> (made from vegetable oils or animal fats). Emerging advanced biofuels use waste, residues, or specially engineered feedstocks to deliver higher lifecycle carbon savings. Beyond emissions benefits, biofuels can support rural livelihoods and circular-economy value chains.
            </p>
          </div>

          <div className="mt-10 md:mt-12 mb-4">
            <div>
              <span className="overline">Latest News</span>
              <h3 className="text-2xl md:text-3xl font-semibold mt-2">In the press</h3>
            </div>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
            {NEWS.map((n, idx) => (
              <a key={idx} href={n.url} target="_blank" rel="noreferrer" className="group block overflow-hidden rounded-lg glass-card hover:shadow-lg transition-shadow">
                <div className="flex gap-4 p-5 items-start">
                  <div className="w-36 h-24 flex-shrink-0 bg-gray-800 rounded-md overflow-hidden">
                    <img src={n.thumb} alt="news thumbnail" className="w-full h-full object-cover" />
                  </div>
                  <div className="flex-1">
                    <div className="text-sm text-white/60">Press</div>
                    <div className="font-medium mt-1 text-lg group-hover:text-green-300">{n.title}</div>
                    <div className="text-sm text-white/60 mt-2">Read more on the publisher site.</div>
                  </div>
                </div>
              </a>
            ))}
          </div>
        </div>

        {/* Flagship Initiatives removed as requested */}

      </div>
    </section>
  );
}